/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Tax_CodeInputs */

const en_reference_field_tax_code = /** @type {(inputs: Reference_Field_Tax_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax code`)
};

/**
* | output |
* | --- |
* | "Tax code" |
*
* @param {Reference_Field_Tax_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_tax_code = /** @type {((inputs?: Reference_Field_Tax_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Tax_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_tax_code(inputs)
});